export { default as translations } from './translations.json';

/**
 * Get price alerts from listing.
 * @param {Object|null} listing
 * @returns {Object[]}
 */
export const getPriceAlerts = (listing) =>
  listing?.attributes?.metadata?.priceAlerts || [];

/**
 * Check if user has an alert for this listing.
 * @param {Object|null} listing
 * @param {string} userId
 * @returns {boolean}
 */
export const hasAlert = (listing, userId) =>
  getPriceAlerts(listing).some(a => a.userId === userId);

/**
 * Get user's target price for a listing.
 * @param {Object|null} listing
 * @param {string} userId
 * @returns {number|null}
 */
export const getUserTargetPrice = (listing, userId) =>
  getPriceAlerts(listing).find(a => a.userId === userId)?.targetPriceCents ?? null;

/**
 * Check if current price triggers any alerts.
 * @param {Object[]} alerts
 * @param {number} currentPriceCents
 * @returns {Object[]}
 */
export const getTriggeredAlerts = (alerts, currentPriceCents) =>
  alerts.filter(a => currentPriceCents <= a.targetPriceCents);
